import api from "@services/axios/apiManager";
import { useKiosk } from "./useKiosk";

/** 簡訊 OTP 的有效倒數秒數（與 OtpCard 的重送倒數一致）。 */
export const OTP_RESEND_SECS = 60;

/**
 * 提早寄出簡訊 OTP。
 *
 * 情境：掃鋼瓶 barcode 綁定的客戶是「免 OTP」完成註冊的，到了結算頁才第一次發簡訊，
 * 使用者得站在結算頁乾等簡訊。改在「前往結帳」按下時就先寄，等他選完配送時間、
 * 走到結算頁，驗證碼通常已經到了。
 *
 * 純粹是提前，不改變驗證規則：仍由 OtpCard 向後端驗證、仍以 otpVerified 為送出依據。
 * 失敗不擋流程（結算頁的 OtpCard 會自己重寄）。
 */
export async function prefetchPhoneOtp(accessToken: string, phone: string): Promise<void> {
  const digits = (phone || "").replace(/\D/g, "");
  if (!accessToken || !/^09\d{8}$/.test(digits)) return;
  const { otpSentPhone, otpSentAt, setOtpSent } = useKiosk.getState();
  // 同一支門號的簡訊還在有效倒數內 → 不重複寄（避免多按幾次就連發簡訊，真簡訊要錢）
  if (otpSentPhone === digits && Date.now() - otpSentAt < OTP_RESEND_SECS * 1000) return;
  try {
    await api.post("/app-api/line/send-phone-otp", { accessToken, phone: digits }, { isAuth: false });
    setOtpSent(digits, Date.now());
  } catch {
    // 靜默失敗：使用者此刻在購物車，不該為了背景預寄跳錯誤；結算頁會再寄一次
  }
}
